import { useCallback } from 'react';
import { CustomAny } from '../../shared/types/generics';
import { usePromiseState } from '../../shared/hooks/promise-state/usePromiseState';

export function useLoadDashboardWidgetData(loadData: (() => Promise<CustomAny>) | undefined): [CustomAny, boolean] {
  return usePromiseState(useCallback(() => (loadData ? loadData() : Promise.resolve(undefined)), [loadData]));
}
